import { RealTimeAction } from '@/_core/fluxstore/types';
import { Annotation, StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class McpSyncStoryMapAnnotations extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'McpSyncStoryMapAnnotations';

    public constructor(public annotations: Annotation[], public deletedAnnotationId?: string) {
        super(McpSyncStoryMapAnnotations.ACTION_TYPE);
    }
}

const middleware = async (): Promise<boolean> => true;

const reducer = (state: StorymapState, action: McpSyncStoryMapAnnotations): void => {
    state.annotations = action.annotations;

    if (!action.deletedAnnotationId) {
        return;
    }

    const removeDeletedAnnotation = (annotationIds: string[]): string[] =>
        annotationIds.filter((id) => id !== action.deletedAnnotationId);

    state.activities.forEach((card) => (card.annotationIds = removeDeletedAnnotation(card.annotationIds)));
    state.tasks.forEach((card) => (card.annotationIds = removeDeletedAnnotation(card.annotationIds)));
    state.subtasks.forEach((card) => (card.annotationIds = removeDeletedAnnotation(card.annotationIds)));
};

//@ts-ignore
registerMiddleware(McpSyncStoryMapAnnotations.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(McpSyncStoryMapAnnotations.ACTION_TYPE, reducer);
